import * as XLSX from 'xlsx'

export interface ExcelColumn<T> {
  header: string
  accessor: (item: T) => string | number | boolean | null | undefined
}

export function exportToExcel<T>(
  data: T[],
  columns: ExcelColumn<T>[],
  filename: string,
) {
  const headers = columns.map((c) => c.header)
  const rows = data.map((item) => columns.map((c) => c.accessor(item) ?? ''))

  const ws = XLSX.utils.aoa_to_sheet([headers, ...rows])

  // Auto-width columns
  ws['!cols'] = headers.map((h, i) => {
    const maxLen = Math.max(
      h.length,
      ...rows.map((r) => String(r[i] ?? '').length),
    )
    return { wch: Math.min(maxLen + 2, 50) }
  })

  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, 'Datos')
  XLSX.writeFile(wb, `${filename}.xlsx`)
}
